/** Extract access token — handles multiple server response envelope formats. */
export function extractAccessToken(data) {
  return (
    data?.data?.tokens?.accessToken ??
    data?.tokens?.accessToken ??
    data?.data?.accessToken ??
    data?.accessToken ??
    data?.data?.access_token ??
    data?.access_token ??
    null
  );
}

export function extractUser(data) {
  return (
    data?.data?.user ??
    data?.user ??
    (data?.data?.id ? data.data : null) ??
    (data?.id ? data : null)
  );
}
